/* tslint:disable */
/* eslint-disable */
/**
 * Bioplan API
 * Backend API for Bioplan, an aquaculture production planning tool.
 *
 * Contact: support@optimeeringaqua.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface QualityModelArguments
 */
export interface QualityModelArguments {
  /**
   *
   * @type {string}
   * @memberof QualityModelArguments
   */
  type: QualityModelArgumentsTypeEnum;
  /**
   *
   * @type {{ [key: string]: any; }}
   * @memberof QualityModelArguments
   */
  parameters: {[key: string]: any};
}

export const QualityModelArgumentsTypeEnum = {
  Fixed: 'fixed',
  Monthly: 'monthly',
  MonthlyInterpolatedMonotonic: 'monthly_interpolated_monotonic',
  AutomaticWoundBased: 'automatic_wound_based',
} as const;

export type QualityModelArgumentsTypeEnum =
  (typeof QualityModelArgumentsTypeEnum)[keyof typeof QualityModelArgumentsTypeEnum];
